module.exports = "<section-header>{{$ctrl.sectionTitle}}</section-header>\n<p class=\"section-description\" ng-bind-html=\"$ctrl.description\"></p>";